<div [formGroup]="form" [attr.class]="class">
  <p-inputSwitch
    [formControlName]="name"
    [id]="id || name"
    [name]="name"
    trueValue="1"
    falseValue="0" />
  <label [for]="name" [attr.class]="classLabel + ' ml-2'">{{ label }}</label>
</div>
